import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";
import styles from "./m3.module.css";

const TONE_CLASS = {
  info: styles.bannerInfo,
  warning: styles.bannerWarning,
  error: styles.bannerError,
  success: styles.bannerSuccess,
  tertiary: styles.bannerTertiary,
};

/**
 * Inline message banner. Pass onDismiss to show a close button.
 *
 * @param {"info"|"warning"|"error"|"success"|"tertiary"} tone
 */
const Banner = ({ tone = "info", icon, children, onDismiss }) => {
  const { t } = useTranslation();
  return (
    <div className={`${styles.banner} ${TONE_CLASS[tone] || styles.bannerInfo}`} role={tone === "error" ? "alert" : "status"}>
      {icon && <span className={styles.bannerIcon}>{icon}</span>}
      <div className={styles.bannerBody}>{children}</div>
      {onDismiss && (
        <button type="button" className={`${styles.iconBtn} ${styles.iconBtnSm} ${styles.iconBtnInherit}`} onClick={onDismiss} aria-label={t("Dismiss")}>
          <CloseIcon />
        </button>
      )}
    </div>
  );
};

export default Banner;
